import React from "react";
import { Snackbar } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { closeToast } from "../../redux/actions/toast/toastActions";
import Slide from "@material-ui/core/Slide";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import ToastCheck from "../../assets/images/toast-check.svg";
import ToastError from "../../assets/images/caution.svg";
import Close from "../../assets/images/Close.svg";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
	props,
	ref
) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Toast() {
	const Toast = useSelector((state) => state.toast);
	const { toastOpened, toastContent, toastStyles, toastType } = Toast;
	const dispatch = useDispatch();
	const useStyles = makeStyles(() =>
		createStyles({
			root: {
				zIndex: 1400,
				"& div:first-child": toastStyles,
			},
		})
	);
	const classes = useStyles();

	const payload = {
		toastContent: "test",
	};

	return (
		<>
			{toastOpened ? (
				<Slide direction="left" in={true} mountOnEnter unmountOnExit>
					<Snackbar
						anchorOrigin={{ vertical: "top", horizontal: "right" }}
						classes={{ root: classes.root }}
						transitionDuration={100}
						open={toastOpened}
						onClose={() => dispatch(closeToast())}
						autoHideDuration={7000}
					>
						{toastContent && (
							<div
								style={{
									// ...toastStyles,
									backgroundColor: "#FFFFFF !important",
									border:
										toastType === "error"
											? "2px solid #EB5757"
											: "2px solid #25AE60",
									borderRadius: "40px",
									fontWeight: 400,
									color: toastType === "error" ? "#EB5757" : "#25AE60",
									fontFamily: "Avenir",
									fontStyle: "normal",
									fontSize: "14px",
									lineHeight: "25px",
									width: "400px",
									padding: "20px 20px",
									height: "60px",
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								{toastType === "success" ? (
									<span
										style={{
											width: "35px",
											height: "35px",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
										}}
									>
										<img src={ToastCheck} alt="toast-check" />
									</span>
								) : (
									<span
										style={{
											width: "35px",
											height: "35px",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
										}}
									>
										<img src={ToastError} alt="toast-error" />
									</span>
								)}
								{toastContent}

								<span
									onClick={() => dispatch(closeToast())}
									style={{ cursor: "pointer" }}
								>
									<img src={Close} alt="" />
								</span>
							</div>
						)}
					</Snackbar>
				</Slide>
			) : null}
		</>
	);
}
